import { Controller } from "@hotwired/stimulus"

import Swal from 'sweetalert2';

export default class extends Controller {
  static targets = ['destinatario', 'acao'];

  async solicitarCorrecaoServidor(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const form = document.getElementById('form-relatorio-dgp')

    const motivoCorrecao = document.getElementById('relatorio_motivo_correcao');

    const result = await Swal.fire({
      title: 'Solicitar correção para o servidor',
      input: 'textarea',
      text: 'Atenção: a chefia deverá conferir o relatório novamente após a correção do servidor.',
      inputLabel: "Informe o motivo abaixo:",
      inputPlaceholder: "Digite o motivo aqui...",
      inputAttributes: {
        "aria-label": "Digite o motivo aqui...",
      },
      inputValue: '',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Salvar',
      backdrop: true,
      focusCancel: true,
      allowOutsideClick: false,
      inputValidator(value) {
        if (!value || value.trim().length == 0) {
          return 'Motivo da correção não pode ficar em branco'
        }
      }
    });

    if (result.isConfirmed && result.value) {
      motivoCorrecao.value = result.value;
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'solicitar_correcao';
      hiddenInput.value = 'true';
      form.appendChild(hiddenInput);

      this.destinatarioTarget.value = 'servidor';

      form.submit();
    }
  }

  async solicitarCorrecaoChefe(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const form = document.getElementById('form-relatorio-dgp')

    const motivoCorrecao = document.getElementById('relatorio_motivo_correcao');

    const result = await Swal.fire({
      title: 'Solicitar correção para o chefe',
      input: 'textarea',
      inputLabel: "Informe o motivo abaixo",
      inputPlaceholder: "Digite o motivo aqui...",
      inputAttributes: {
        "aria-label": "Digite o motivo aqui...",
      },
      inputValue: '',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Salvar',
      backdrop: true,
      focusCancel: true,
      allowOutsideClick: false,
      inputValidator(value) {
        if (!value || value.trim().length == 0) {
          return 'Motivo da correção não pode ficar em branco'
        }
      }
    });

    if (result.isConfirmed && result.value) {
      motivoCorrecao.value = result.value;
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'solicitar_correcao';
      hiddenInput.value = 'true';
      form.appendChild(hiddenInput);

      this.destinatarioTarget.value = 'chefe';

      form.submit();
    }
  }

  async aprovar(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const form = document.getElementById('form-relatorio-dgp')

    const result = await Swal.fire({
      title: 'Atenção!',
      text: 'Tem certeza de que deseja marcar este relatório como aprovado? \n\n Esta ação não poderá ser desfeita.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim',
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      this.acaoTarget.value = 'aprovar';
      form.submit();
    }
  }

  async rejeitar(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const form = document.getElementById('form-relatorio-dgp')

    const result = await Swal.fire({
      title: 'Atenção!',
      text: 'Tem certeza de que deseja marcar este relatório como rejeitado? \n\n Esta ação não poderá ser desfeita.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim',
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      this.acaoTarget.value = 'rejeitar';
      form.submit();
    }
  }

  toggleDetalhes(e) {
    const atividadeId = e.target.dataset.value;
    const descricaoAtividadeElem = document.getElementById(atividadeId);
    if (descricaoAtividadeElem) {
      if (descricaoAtividadeElem.style.display === 'none' || getComputedStyle(descricaoAtividadeElem).display === 'none') {
        descricaoAtividadeElem.style.display = 'inline';
      } else {
        descricaoAtividadeElem.style.display = 'none';
      }
    }
  }
}